module.exports = __webpack_public_path__ + "img/body-position-goal-slide3.e182f2ed.gif";